import React, { useState } from 'react';
import Footer from '../Components/Footer';

const Cookies = () => {
  const [activeTab, setActiveTab] = useState('necessary');
  const [cookieConsent, setCookieConsent] = useState({
    necessary: true,
    preferences: false,
    statistics: false,
    marketing: false
  });

  const handleConsentChange = (type) => {
    if (type === 'necessary') return; // Les cookies nécessaires ne peuvent pas être désactivés
    
    setCookieConsent(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  const savePreferences = () => {
    // Ici, vous pourriez enregistrer les préférences dans un cookie
    alert('Vos préférences de cookies ont été enregistrées avec succès.');
  };

  // Styles réutilisables
  const sectionStyle = {
    marginBottom: '2.5rem',
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255, 255, 255, 0.05)'
  };

  const sectionHeaderStyle = {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#ffffff',
    margin: 0,
    padding: '1.25rem 2rem',
    background: 'linear-gradient(90deg, rgba(14, 165, 233, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  };

  const sectionContentStyle = {
    padding: '1.5rem 2rem'
  };

  const paragraphStyle = {
    color: '#e2e8f0', 
    margin: '0 0 1rem 0',
    lineHeight: '1.7'
  };

  const listStyle = {
    paddingLeft: '1.5rem',
    margin: '0 0 1rem 0'
  };

  const listItemStyle = {
    marginBottom: '0.5rem',
    lineHeight: '1.7'
  };

  const highlightStyle = {
    color: '#0ea5e9',
    fontWeight: 600
  };

  const tabStyle = (isActive) => ({
    padding: '0.75rem 1.5rem',
    border: 'none',
    background: isActive ? 'rgba(14, 165, 233, 0.2)' : 'transparent',
    color: isActive ? '#0ea5e9' : '#94a3b8',
    cursor: 'pointer',
    borderBottom: isActive ? '2px solid #0ea5e9' : '2px solid transparent',
    fontWeight: isActive ? 600 : 400,
    transition: 'all 0.2s'
  });

  const switchStyle = (isOn) => ({
    position: 'relative',
    display: 'inline-block',
    width: '50px',
    height: '24px',
    marginRight: '10px'
  });

  const sliderStyle = (isOn) => ({
    position: 'absolute',
    cursor: isOn ? 'default' : 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isOn ? '#0ea5e9' : '#334155',
    transition: '.4s',
    borderRadius: '24px',
    '&:before': {
      position: 'absolute',
      content: '""',
      height: '16px',
      width: '16px',
      left: isOn ? 'calc(100% - 20px)' : '4px',
      bottom: '4px',
      backgroundColor: 'white',
      transition: '.4s',
      borderRadius: '50%'
    }
  });

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #0f172a 0%, #111827 35%, #0b1220 100%)',
      color: 'white',
      padding: '2rem 0'
    }}>
      <main style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '3rem',
          padding: '2rem',
          background: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            color: '#ffffff',
            marginBottom: '1rem',
            background: 'linear-gradient(90deg, #0ea5e9, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            Gestion des Cookies
          </h1>
          <p style={{
            fontSize: '1.125rem',
            color: '#94a3b8',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            Contrôlez votre expérience en gérant vos préférences de cookies
          </p>
        </div>

        <div style={{
          backgroundColor: 'rgba(15, 23, 42, 0.7)',
          borderRadius: '16px',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{ 
            padding: '2.5rem',
            background: 'linear-gradient(180deg, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 0.7) 100%)'
          }}>
            {/* Introduction */}
            <section style={{ 
              marginBottom: '3rem',
              padding: '2rem',
              background: 'rgba(15, 23, 42, 0.5)',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.05)'
            }}>
              <p style={{
                color: '#e2e8f0',
                lineHeight: '1.7',
                fontSize: '1.1rem',
                margin: 0
              }}>
                Notre site utilise des cookies pour améliorer votre expérience de navigation. Les cookies sont de petits fichiers texte qui sont stockés sur votre appareil pour vous reconnaître lorsque vous revenez sur notre site. Vous pouvez personnaliser vos préférences ci-dessous.
              </p>
            </section>

            {/* Navigation par onglets */}
            <div style={{
              display: 'flex',
              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
              marginBottom: '2rem'
            }}>
              <button 
                style={tabStyle(activeTab === 'about')}
                onClick={() => setActiveTab('about')}
              >
                À propos des cookies
              </button>
              <button 
                style={tabStyle(activeTab === 'settings')}
                onClick={() => setActiveTab('settings')}
              >
                Paramètres
              </button>
            </div>

            {/* Contenu des onglets */}
            {activeTab === 'about' ? (
              <>
                <section style={sectionStyle}>
                  <h2 style={sectionHeaderStyle}>
                    Qu'est-ce qu'un cookie ?
                  </h2>
                  <div style={sectionContentStyle}>
                    <p style={paragraphStyle}>
                      Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, tablette, smartphone) lorsque vous visitez un site web. Les cookies sont largement utilisés pour faire fonctionner les sites web ou les rendre plus efficaces, ainsi que pour fournir des informations aux propriétaires du site.
                    </p>
                  </div>
                </section>

                <section style={sectionStyle}>
                  <h2 style={sectionHeaderStyle}>
                    Types de cookies que nous utilisons
                  </h2>
                  <div style={sectionContentStyle}>
                    <ul style={listStyle}>
                      <li style={listItemStyle}>
                        <span style={highlightStyle}>Cookies nécessaires :</span> Essentiels au bon fonctionnement du site. Ils vous permettent de naviguer sur le site et d'utiliser ses fonctionnalités.
                      </li>
                      <li style={listItemStyle}>
                        <span style={highlightStyle}>Cookies de préférences :</span> Permettent au site de retenir les choix que vous faites pour personnaliser votre expérience.
                      </li>
                      <li style={listItemStyle}>
                        <span style={highlightStyle}>Cookies statistiques :</span> Nous aident à comprendre comment les visiteurs interagissent avec notre site en collectant des informations de manière anonyme.
                      </li>
                      <li style={{...listItemStyle, marginBottom: 0}}>
                        <span style={highlightStyle}>Cookies marketing :</span> Utilisés pour suivre les visiteurs à travers les sites web afin d'afficher des publicités pertinentes.
                      </li>
                    </ul>
                  </div>
                </section>
              </>
            ) : (
              <section style={sectionStyle}>
                <h2 style={sectionHeaderStyle}>
                  Personnaliser vos préférences
                </h2>
                <div style={sectionContentStyle}>
                  <p style={paragraphStyle}>
                    Activez ou désactivez les différents types de cookies ci-dessous :
                  </p>

                  <div style={{ 
                    margin: '1.5rem 0',
                    padding: '1.5rem',
                    background: 'rgba(15, 23, 42, 0.3)',
                    borderRadius: '8px'
                  }}>
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      marginBottom: '1rem',
                      paddingBottom: '1rem',
                      borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
                    }}>
                      <div>
                        <h3 style={{ 
                          color: '#ffffff', 
                          margin: '0 0 0.25rem 0',
                          fontSize: '1.1rem'
                        }}>
                          Cookies nécessaires
                        </h3>
                        <p style={{ 
                          color: '#94a3b8', 
                          margin: 0,
                          fontSize: '0.9rem'
                        }}>
                          Essentiels au bon fonctionnement du site
                        </p>
                      </div>
                      <label style={switchStyle(true)}>
                        <input 
                          type="checkbox" 
                          checked={true} 
                          disabled 
                          style={{ display: 'none' }} 
                        />
                        <span style={{
                          ...sliderStyle(true),
                          backgroundColor: '#0ea5e9',
                          opacity: 0.7
                        }}></span>
                      </label>
                    </div>

                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      marginBottom: '1rem',
                      paddingBottom: '1rem',
                      borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
                    }}>
                      <div>
                        <h3 style={{ 
                          color: '#ffffff', 
                          margin: '0 0 0.25rem 0',
                          fontSize: '1.1rem'
                        }}>
                          Cookies de préférences
                        </h3>
                        <p style={{ 
                          color: '#94a3b8', 
                          margin: 0,
                          fontSize: '0.9rem'
                        }}>
                          Mémorisent vos choix et paramètres
                        </p>
                      </div>
                      <label style={switchStyle(cookieConsent.preferences)}>
                        <input 
                          type="checkbox" 
                          checked={cookieConsent.preferences} 
                          onChange={() => handleConsentChange('preferences')}
                          style={{ display: 'none' }} 
                        />
                        <span style={sliderStyle(cookieConsent.preferences)}></span>
                      </label>
                    </div>

                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      marginBottom: '1rem',
                      paddingBottom: '1rem',
                      borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
                    }}>
                      <div>
                        <h3 style={{ 
                          color: '#ffffff', 
                          margin: '0 0 0.25rem 0',
                          fontSize: '1.1rem'
                        }}>
                          Cookies statistiques
                        </h3>
                        <p style={{ 
                          color: '#94a3b8', 
                          margin: 0,
                          fontSize: '0.9rem'
                        }}>
                          Nous aident à améliorer notre site
                        </p>
                      </div>
                      <label style={switchStyle(cookieConsent.statistics)}>
                        <input 
                          type="checkbox" 
                          checked={cookieConsent.statistics} 
                          onChange={() => handleConsentChange('statistics')}
                          style={{ display: 'none' }} 
                        />
                        <span style={sliderStyle(cookieConsent.statistics)}></span>
                      </label>
                    </div>

                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center'
                    }}>
                      <div>
                        <h3 style={{ 
                          color: '#ffffff', 
                          margin: '0 0 0.25rem 0',
                          fontSize: '1.1rem'
                        }}>
                          Cookies marketing
                        </h3>
                        <p style={{ 
                          color: '#94a3b8', 
                          margin: 0,
                          fontSize: '0.9rem'
                        }}>
                          Personnalisent les publicités
                        </p>
                      </div>
                      <label style={switchStyle(cookieConsent.marketing)}>
                        <input 
                          type="checkbox" 
                          checked={cookieConsent.marketing} 
                          onChange={() => handleConsentChange('marketing')}
                          style={{ display: 'none' }} 
                        />
                        <span style={sliderStyle(cookieConsent.marketing)}></span>
                      </label>
                    </div>
                  </div>

                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'flex-end',
                    gap: '1rem',
                    marginTop: '2rem'
                  }}>
                    <button 
                      style={{
                        padding: '0.75rem 1.5rem',
                        background: 'transparent',
                        border: '1px solid #0ea5e9',
                        color: '#0ea5e9',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        ':hover': {
                          background: 'rgba(14, 165, 233, 0.1)'
                        }
                      }}
                      onClick={() => {
                        setCookieConsent({
                          necessary: true,
                          preferences: false,
                          statistics: false,
                          marketing: false
                        });
                      }}
                    >
                      Tout refuser
                    </button>
                    <button 
                      style={{
                        padding: '0.75rem 1.5rem',
                        background: 'transparent',
                        border: '1px solid #0ea5e9',
                        color: '#0ea5e9',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        ':hover': {
                          background: 'rgba(14, 165, 233, 0.1)'
                        }
                      }}
                      onClick={() => {
                        setCookieConsent({
                          necessary: true,
                          preferences: true,
                          statistics: true,
                          marketing: true
                        });
                      }}
                    >
                      Tout accepter
                    </button>
                    <button 
                      style={{
                        padding: '0.75rem 1.5rem',
                        background: '#0ea5e9',
                        border: '1px solid #0ea5e9',
                        color: 'white',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        ':hover': {
                          background: '#0d94d8'
                        }
                      }}
                      onClick={savePreferences}
                    >
                      Enregistrer les préférences
                    </button>
                  </div>
                </div>
              </section>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Cookies;